import { InjectionToken } from '@angular/core';

import { AccountStatsFacade } from './account-stats.facade';

export const ACCOUNT_STATS_FACADE =
  new InjectionToken<AccountStatsFacade>('ACCOUNT_STATS_FACADE');